export default postalOperators => postalOperators
  .filter(postalOperator =>
    postalOperator.mailProcessingCenters && postalOperator.mailProcessingCenters.length)
  .map(postalOperator => ({
    value: postalOperator.shortPostalOperatorCode,
    label:
    // eslint-disable-next-line no-nested-ternary
        (postalOperator.shortPostalOperatorCode ? `${postalOperator.shortPostalOperatorCode} - ` : '') + (postalOperator.longName
      ? postalOperator.longName : (postalOperator.shortName ? postalOperator.shortName : '')),
  }));
